package nl.volleyplanner.web.controller

import kotlinx.browser.document
import kotlinx.html.div
import kotlinx.html.dom.create
import kotlinx.html.h2
import kotlinx.html.p
import nl.volleyplanner.web.base.PageController
import org.w3c.dom.HTMLElement

open class ErrorController(val title: String, val message: String) : PageController() {
    override val name = "ErrorController"

    override fun createRuntimeInstance() = ErrorController(title, message)

    override suspend fun render(): HTMLElement {
        return document.create.div(classes = "container") {
            h2 { +title }
            p { +message }
        }
    }
}

class InvalidLinkController : ErrorController("Geen toegang", "Mogelijk heb je een onjuiste link ontvangen voor deze pagina. Vraag een nieuwe link op") {
    override val name = "InvalidLinkController"
}

class ForbiddenController : ErrorController("Geen toegang", "Je hebt geen toegang tot deze pagina") {
    override val name = "ForbiddenController"
}
